module.exports = __webpack_public_path__ + "static/media/HeroBackground-Option2-01.8564ae21.png";